<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow" v-loading="loading">     
      
      <div class="shipping-order-numbers">
        <div class="shipping-order-title">当前订单编号：{{orders.ordernumber}}</div>
        <el-button type="danger" round size="mini" style="display:inline-block;margin-left:10px" @click="addshippings">新增快递</el-button>
        <el-button type="primary" round size="mini" style="float:right" @click="saveordershippings">保 存</el-button>
        <el-button round size="mini" style="float:right" @click="closesetting">取 消</el-button>
      </div>
      <div class="shipping-order-content">
        <div class="shipping-order-content-left">
          <div class="shipping-order-content-left-name">
              <div style="display:inline-block;">剩余未分配商品：<i>{{shippingdatas.lastgoods.length}}</i></div>
              <el-button type="danger" size="mini" style="display:inline-block;margin-left:2%" @click="setallinshippings">全部添加进快递</el-button>
          </div>
          <div class="shipping-order-content-left-goods" v-for="(item,index) in shippingdatas.lastgoods" :key="index">
             <div class="shipping-order-content-left-imgs">
                <i v-if="item.type=='赠送'">送</i><img :src="item.thumb=='' ? require('../../../assets/default_img_mini.png') : GLOBAL.staticUrl+item.thumb" />
             </div>
             <div class="shipping-order-content-left-names">
                <div class="shipping-order-content-left-goodsname">{{item.goodsname}}</div>
                <div class="shipping-order-content-left-spec">规格：{{item.propertyname}}</div>
             </div>
             <div class="shipping-order-content-left-button">
                <el-button type="warning" size="mini" round @click="setinshippings(index)">添加进快递</el-button>
             </div>
          </div>
        </div>

        <div class="shipping-order-content-right">
            <div class="shipping-order-content-right-logistics">
                <div class="shipping-order-lists-infos" v-for="(item,index) in shippingdatas.shippings" @click="checkshippings(index)">
                   <div class="shipping-order-lists-setting">
                      <div class="shipping-order-lists-setting-type" style="max-width:50%;text-align:left;font-size:13px">商品数量：<i>{{item.goods.length}}</i></div>
                      <el-button type="warning" size="mini" circle icon="el-icon-setting" @click="settingshippings(index)"></el-button>
                      <el-button type="danger" size="mini" circle icon="el-icon-delete" @click="delshippings(index)"></el-button>
                   </div>
                   <div class="shipping-order-lists-setting-type">快递名称：{{item.shippingname}}（{{item.shippingcode}}）</div>
                   <div class="shipping-order-lists-setting-type">快递单号：{{item.code}}</div>
                </div>
            </div>

            <div class="shipping-order-content-logistics-goods">
                <div class="shipping-order-content-left-name" style="margin:10px 0" v-if="shippinggoods.shippingid > 0">
                    <div style="display:inline-block;">{{shippinggoods.shippingname}}（{{shippinggoods.shippingcode}}）：{{shippinggoods.code}}</div>
                    <el-button type="danger" size="mini" style="display:inline-block;margin-left:2%" @click="callbackallgoods">删除全部商品</el-button>
                </div>
                <div class="shipping-order-content-left-goods" v-for="(item,index) in shippinggoods.goods" :key="index">
                    <div class="shipping-order-content-left-imgs" style="width:7%">
                        <i v-if="item.type=='赠送'">送</i><img :src="item.thumb=='' ? require('../../../assets/default_img_mini.png') : GLOBAL.staticUrl+item.thumb" />
                    </div>
                    <div class="shipping-order-content-left-names" style="width:63%">
                        <div class="shipping-order-content-left-goodsname">{{item.goodsname}}</div>
                        <div class="shipping-order-content-left-spec">规格：{{item.propertyname}}</div>
                    </div>
                    <div class="shipping-order-content-left-button" style="width:13%">
                        <el-button type="danger" size="mini" round @click="delgoods(index)">删除商品</el-button>
                    </div>
                </div>
            </div>
        </div>
      </div>


      <el-dialog title="添加/编辑快递" :visible.sync="addshippingDialog" top="25vh" width="26%" :modal-append-to-body='false'>
          <div style="display:inline-block;width:100%" v-loading="addlogisticsquery.loading">
              <el-form :inline="true" size="mini">
                  <el-form-item label="快递类型" label-width="100">
                    <el-select v-model="addlogisticsquery.shippingid" clearable remote  filterable placeholder="请选择快递类型">	            
                      <el-option v-for="(item,index) in otherlogistics" :label="item.showlable" :value="item.id" :key="index">
                        <span style="float: left">{{item.name}}</span>
                        <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
                      </el-option>              
                    </el-select>
                  </el-form-item>
                  <el-form-item label="快递单号" label-width="100">
                    <el-input v-model="addlogisticsquery.code" clearable placeholder="请填写快递单号"></el-input>
                  </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer" style="text-align:right;margin-top:20px">
                    <el-button size="small" @click="addshippingDialog = false">取 消</el-button>
                    <el-button size="small" type="primary" @click="saveshippings">确 定</el-button>
              </div>
          </div>
      </el-dialog>


          
  </div>
  </transition> 
</template>

<script>
export default {
  props: ["value","orderinfos"],
  data () {
    return {
      url:this.GLOBAL.domain+"Sellshippingbirld/index",
      transitionshow:true,
      orderid:'',
      orders:'',
      loading:false,
      shippingdatas:'',
      shippinggoods:[],
      otherlogistics:[],

      addshippingDialog:false,
      addlogisticsquery: {
         loading:false,
         sortid:0,
         shippingid:'',
         shippingname:'',
         shippingcode:'',
         code:'',
      },

    }  
  },

  watch: {

    //获取当前订单快递信息
    value(val) {
      if (val) {
          this.orderid=val;
          this.orders=this.orderinfos;
          this.getordershipping();
      }
    },

  },

  mounted(){
     //获取当前订单快递信息
     this.orderid=this.value;
     this.orders=this.orderinfos;
     this.getallshippinglogistics(); //获取所有物流快递信息
     this.getordershipping();
  },

  methods:{

       //保存快递信息
       saveordershippings() {

          //压缩快递单与商品数据 
          var param=this.shippingdatas.shippings;
          var shippings='';
          var data=[];
          param.forEach(function(item,i) {
              shippings={id:item.id,shippingid:item.shippingid,code:item.code,goods:[]};
              item.goods.forEach(function(tt,ii) {
                  shippings.goods.push({infoid:tt.infoid,activeid:tt.activeid,goodsid:tt.goodsid,type:tt.type});
              });
              data.push(shippings);
          });
          
          data=JSON.stringify(data);
          this.$confirm('保存该设置将会使订单物流信息发生改变，是否继续？', '提示', { type: 'warning' }).then(() => {
              this.loading=true;
              var resource = this.$resource(this.url);
              resource.save({act:'savemallordershippinglists',token:this.$cookies.get('token'),orderid:this.orderid,data:data}).then((res) => {
                  if(res.data.Result>0){
                      if(res.data.Result=='70001') this.$router.push('/login')
                      this.$message.error(res.data.Message);
                      this.loading=false;
                  }else{
                      this.loading=false;
                      this.shippingorderid='';
                      this.$emit("finish",'');
                  }
              }).catch((res) => {
                  this.loading=false;
              });

		  }).catch(() => {
              
          });
       },



       //删除快递
       delshippings(index) {
           var goods=this.shippingdatas.shippings[index].goods;
           var _this=this;
           goods.forEach(function(item,i) {
              _this.shippingdatas.lastgoods.push(item);
           });

           setTimeout(function() {
              _this.$delete(_this.shippingdatas.shippings,index);
              _this.shippinggoods=[];
           },200);
       },

       //删除单个商品
       delgoods(index) {
          var data=this.shippinggoods.goods[index];
          this.shippingdatas.lastgoods.push(data);
          this.$delete(this.shippinggoods.goods,index);
       },

       //全部撤销已添加的商品
       callbackallgoods() {
          var _this=this;
          this.shippinggoods.goods.forEach(function(item,i) {
              _this.shippingdatas.lastgoods.push(item);
          });
          this.shippinggoods.goods=[];
       },

       //将商品全部添加进快递里
       setallinshippings() {
           if(!this.shippinggoods.shippingid) {this.$message.error("请选择要添加进入的快递");return false;}
           var _this=this;
           this.shippingdatas.lastgoods.forEach(function(item,index) {
               _this.shippinggoods.goods.push(item);
           });

           this.shippingdatas.lastgoods=[];
       },

       //添加剩余商品进入快递
       setinshippings(index) {
          if(!this.shippinggoods.shippingid) {this.$message.error("请选择要添加进入的快递");return false;}

          var data=this.shippingdatas.lastgoods[index];
          this.shippinggoods.goods.push(data);
          this.$delete(this.shippingdatas.lastgoods,index);
       },


      //查看快递商品信息
      checkshippings(index) {
          this.shippinggoods=this.shippingdatas.shippings[index];
      },


      //新增快递信息
      addshippings() {
          this.addshippingDialog=true;
          this.addlogisticsquery.loading=true;
          this.addlogisticsquery.sortid=-1;
          this.addlogisticsquery.shippingid='';
          this.addlogisticsquery.shippingname='';
          this.addlogisticsquery.shippingcode='';
          this.addlogisticsquery.code='';
          this.addlogisticsquery.loading=false;
      },

      //编辑快递信息
      settingshippings(index) {
          var data=this.shippingdatas.shippings[index];
          this.addshippingDialog=true;
          this.addlogisticsquery.loading=true;
          this.addlogisticsquery.sortid=index;
          this.addlogisticsquery.shippingid=data.shippingid;
          this.addlogisticsquery.code=data.code;
          this.addlogisticsquery.loading=false;
      },


      //保存添加/编辑的快递信息
      saveshippings() {
          if(this.addlogisticsquery.shippingid=='') {this.$message.error('请选择快递');return false;}
          if(this.addlogisticsquery.code=='') {this.$message.error('请填写快递单号');return false;}

          this.addlogisticsquery.loading=true;
          var logisticsid=''; 
          var logisticsname=''; 
          var logisticscode=''; 
          var code=this.addlogisticsquery.code; 
          var sortid=this.addlogisticsquery.sortid;
          var _this=this;
          
          this.otherlogistics.forEach(function(item,i) {
              if(item.id==_this.addlogisticsquery.shippingid) {
                  logisticsid=item.id;
                  logisticsname=item.name;
                  logisticscode=item.code;
              }
          });
          
          if(sortid==-1) { //新增
              var data={id:0,shippingid:logisticsid,shippingname:logisticsname,shippingcode:logisticscode,code:code,goods:[]};
              this.shippingdatas.shippings.push(data);
          }else { //编辑
              this.shippingdatas.shippings[sortid].shippingid=logisticsid;
              this.shippingdatas.shippings[sortid].shippingname=logisticsname;
              this.shippingdatas.shippings[sortid].shippingcode=logisticscode;
              this.shippingdatas.shippings[sortid].code=code;
          }
          this.addlogisticsquery.loading=false;
          this.addshippingDialog=false;
      },


      //获取当前订单快递信息
      getordershipping() {
          this.loading=true;
          var resource = this.$resource(this.url);
          resource.save({act:'getmallordershippinglists',token:this.$cookies.get('token'),orderid:this.orderid}).then((res) => {
            if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.loading=false;
            }else{
              var result = JSON.parse(Base64.decode(res.data.Data));
              this.shippingdatas=result;
              this.shippinggoods='';
              this.loading=false;
            }
          }).catch((res) => {
              this.loading=false;
          });
      },
      

      //获取第三方商品发货快递信息
      getallshippinglogistics() {
          var resource = this.$resource(this.GLOBAL.domain+"Order/index");
          resource.query({act:'getallshippinglists',token:this.$cookies.get('token')}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  this.otherlogistics=JSON.parse(Base64.decode(res.data.Data));
              }
          }).catch((res) => {
              
          });
      },


      //关闭当前窗口
      closesetting() {
          this.$emit("finish",'');
      },



  }

}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 1% 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.shipping-order-numbers {display:inline-block;width:100%;font-size:13px;font-weight:540;border-bottom:1px solid #dddddd;padding:0 0 20px 0;}
.shipping-order-title {display:inline-block;}
.shipping-order-content {display:inline-block;width:100%;border-bottom:1px solid #dddddd;}
.shipping-order-content-left {float:left;width:35%;height:500px;padding:10px 1% 10px 0;overflow-y:scroll;}
.shipping-order-content-left::-webkit-scrollbar {width:5px;height:5px;}
.shipping-order-content-left::-webkit-scrollbar-thumb {border-radius: 15px;-webkit-box-shadow: inset 0 0 5px rgba(220,223,230,0.2);background: rgba(96,98,102,0.4);}
.shipping-order-content-left::-webkit-scrollbar-track {-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);border-radius: 0;background: rgba(0,0,0,0.1);}

.shipping-order-content-left-name {font-size:13px;font-weight:540;margin:10px 0;display:inline-block;width:100%;}
.shipping-order-content-left-name i {font-style:normal;font-size:14px;font-weight:600;color:#f78989}
.shipping-order-content-left-goods {display:flex;align-items:center;padding:10px 2% 10px 0;width:98%;border-bottom:1px dashed #dddddd;}
.shipping-order-content-left-imgs {width:12%;height:60px;border-radius:6px;background:hsla(0,0%,87%,.4);display:flex;justify-content:center;align-items:center;position:relative}
.shipping-order-content-left-imgs img {max-width:80%;max-height:80%;border-radius:6px}
.shipping-order-content-left-imgs i {font-style:normal;width:35%;height:35%;background:#f56c6c;border-radius:50%;font-size:12px;color:#fff;position:absolute;display:flex;justify-content:center;align-items:center;overflow:hidden;margin-top:-85%;margin-left:85%}
.shipping-order-content-left-names {width:58%;height:60px;margin-left:2%;display:inline-block;}
.shipping-order-content-left-goodsname {width:100%;font-size:13px;color:#666666;line-height:23px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;}
.shipping-order-content-left-spec {width:100%;font-size:12px;color:#999999;line-height:23px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;}
.shipping-order-content-left-button {width:23%;height:60px;margin-left:2%;display:flex;justify-content:center;align-items:center;overflow:hidden;}

.shipping-order-content-right {float:left;width:63%;height:520px;padding:0 0 0 1%;}
.shipping-order-content-right-logistics {float:left;width:100%;height:200px;padding:10px 0;overflow-y:scroll;border-bottom:1px solid #ddd}
.shipping-order-content-right-logistics::-webkit-scrollbar {width:5px;height:5px;}
.shipping-order-content-right-logistics::-webkit-scrollbar-thumb {border-radius: 15px;-webkit-box-shadow: inset 0 0 5px rgba(220,223,230,0.2);background: rgba(96,98,102,0.4);}
.shipping-order-content-right-logistics::-webkit-scrollbar-track {-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);border-radius: 0;background: rgba(0,0,0,0.1);}
.shipping-order-lists-infos {transition:.3s all;cursor:pointer;margin-bottom:20px;margin-right:3%;display:inline-block;width:28%;padding:5px 1% 5px 1%;border:1px solid #dddddd;border-radius:6px;}
.shipping-order-lists-infos:nth-child(3n+0) {margin-right:0}
.shipping-order-lists-infos:hover {box-shadow:5px 5px 10px #999999}
.shipping-order-lists-setting {display:inline-block;padding:5px 0;width:100%;border-bottom:1px solid #dddddd;text-align:right}
.shipping-order-lists-setting-type {float:left;width:100%;margin-top:3px;font-size:12px;line-height:20px;color:#666666;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;}
.shipping-order-lists-setting-type i {font-style:normal;color:#f56c6c;font-weight:600}

.shipping-order-content-logistics-goods {float:left;width:100%;height:275px;padding:10px 0;overflow-y:scroll;}
.shipping-order-content-logistics-goods::-webkit-scrollbar {width:5px;height:5px;}
.shipping-order-content-logistics-goods::-webkit-scrollbar-thumb {border-radius: 15px;-webkit-box-shadow: inset 0 0 5px rgba(220,223,230,0.2);background: rgba(96,98,102,0.4);}
.shipping-order-content-logistics-goods::-webkit-scrollbar-track {-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);border-radius: 0;background: rgba(0,0,0,0.1);}

</style>


// WEBPACK FOOTER //
// src/components/mall/shipping/shippings.vue